import { render } from "./Deactivate.vue?vue&type=template&id=53d473a5&scoped=true"
import script from "./Deactivate.vue?vue&type=script&lang=js"
export * from "./Deactivate.vue?vue&type=script&lang=js"

import "./custom-deactivate.scss?vue&type=style&index=0&id=53d473a5&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d473a5"]])

export default __exports__